<template>
  <div class="industries-list">
    <span class="labelIndustries"><strong>Industries: </strong></span>
    <span v-if="IndustriesLess && facilitiesCategories">
      <span
        v-for="(val, index) of facilitiesCategories.slice(0, loadMoreThreshold)"
        :key="index"
      >
        {{
          index != facilitiesCategories.length - 1 &&
          index != loadMoreThreshold - 1
            ? `${val.category}, `
            : val.category
        }}</span
      >
      <span
        class="load-more__industry"
        @click="IndustriesLess = false"
        v-if="
          facilitiesCategories?.length > loadMoreThreshold && IndustriesLess
        "
        >Show
        {{ facilitiesCategories.length - loadMoreThreshold }}
        More
        <font-awesome-icon icon="angle-down" />
      </span>
    </span>
    <span v-else-if="facilitiesCategories">
      <span v-for="(val, index) of facilitiesCategories" :key="index">
        {{
          index != facilitiesCategories.length - 1
            ? `${val.category}, `
            : val.category
        }}</span
      >
      <span
        class="load-more__industry"
        @click="IndustriesLess = true"
        v-if="
          facilitiesCategories &&
          facilitiesCategories.length > loadMoreThreshold &&
          !IndustriesLess
        "
        >Show Less <font-awesome-icon icon="angle-up" />
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { CoPackerFacilitiesCategory } from "@/Domain/CoPackerFacilitiesCategory";

defineProps<{
  facilitiesCategories: CoPackerFacilitiesCategory[];
}>();

const IndustriesLess = ref(true);

const loadMoreThreshold = 5;
</script>

<style lang="scss">
.load-more__industry {
  text-decoration: underline;
  font-size: 11px;
  font-weight: bold;
  color: #399cd3;
  cursor: pointer;
  margin-top: 5px;
  margin-left: 5px;
}

.industries-list {
  font-style: italic;
}
</style>
